import React, { useEffect, useRef, useState } from "react";
import axiosInstance from "../../Services/axiosCommon";
import moment from "moment";
import NuDate from "../../Components/Utils/NuDate";
import logout from "../../Components/Utils/Logout";
import ModalContainer from "../../Components/Others/ModalContainer";
import BellIcon from "../../Components/Icons/BellIcon";
import DecryptData from "../../Components/Utils/Decrypt";
import LanguageSelector from "../../Components/Others/LanguageSelector";
import {
  Link,
  NavLink,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import Dashboard from "../../Components/Icons/Dasboard";
import { useCurrency } from "../../Context/CurrencyContext";
import socketAxiosInstance from "../../Services/socketAxiosCommon";
import {
  GetAccess,
  GetDashboardRole,
  GetMultipleAccess,
  GetRole,
} from "../../Components/Utils/roles";
import { useToast } from "../../Components/Others/ToastServices";
import Chat from "../../Components/Icons/Chat";
import { useSocket } from "../../Context/SocketContext";
import { MenuOutlined } from "@ant-design/icons";
import { Drawer } from "antd";
import Members from "../../Components/Icons/Member";
import DashboardSide from "../../Components/Icons/DasboardSide";
import Bidding from "../../Components/Icons/Bidding";
import Project from "../../Components/Icons/Project";
import Notes from "../../Components/Icons/Notes";
import Procurement from "../../Components/Icons/Procurement";
import Sales from "../../Components/Icons/Sales";
import Store from "../../Components/Icons/Store";
import Contacts from "../../Components/Icons/Contacts";
import Report from "../../Components/Icons/Report";
import Settings from "../../Components/Icons/Settings";
import Costing from "../../Components/Icons/Budget";
import PlanTask from "../../Components/Icons/Planning";
import Task from "../../Components/Icons/Task";
import Progress from "../../Components/Icons/progress";
import Timesheet from "../../Components/Icons/TimeSheet";
import CompanyInfoIcon from "../../Components/Icons/Company";
import Products from "../../Components/Icons/Products";
import Shipping from "../../Components/Icons/Shipping";
import Role from "../../Components/Icons/Role";
import Staff from "../../Components/Icons/Staff";
import UserRole from "../../Components/Icons/UserRole";
import Reference from "../../Components/Icons/Reference";
import CurrencyIcon from "../../Components/Icons/Currency";
import PermissionIcon from "../../Components/Icons/Status";
import Email from "../../Components/Icons/Email";
import Template from "../../Components/Icons/Template";
import PDFTemplateIcon from "../../Components/Icons/PdfTemplate";
import Signature from "../../Components/Icons/Signatutre";
import { BellDot, LayoutDashboard, MessageSquareDot } from "lucide-react";

function Navbar() {
  const toast = useToast();
  const userDetails = DecryptData("sLiAtEdReSuEdArT") || "";
  const hasMutipleOffice = localStorage.getItem("hasmutiple")
    ? JSON.parse(localStorage.getItem("hasmutiple"))
    : false;
  const branchId = localStorage.getItem("branchId")
    ? JSON.parse(localStorage.getItem("branchId"))
    : 1;
  const { officeId } = useParams();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [notifCount, setNotifCount] = useState(0);
  const [msgCount, setMsgCount] = useState(0);
  const [message, setMessage] = useState([]);
  const { updateCurrency } = useCurrency();

  const [open, setOpen] = useState(false);
  const [noti, setNoti] = useState([]);
  const [title, setTitle] = useState({
    Name: "",
    Country: "",
  });

  function getCompanyName() {
    axiosInstance
      .get(`/company-info/1`)
      .then((res) => {
        res.data?.data &&
          setTitle({
            Name: res.data?.data?.companyName,
            Country: res.data.data?.compLogo?.file || "",
          });
        updateCurrency(res.data.data?.currency);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function getNotifications(userId) {
    socketAxiosInstance
      .get(`/notification/${userId}`)
      .then((res) => {
        if (res?.data?.status === true) {
          let data = res?.data?.data;

          data && setNoti(data?.notifications || []);
          data && setNotifCount(data?.count || 0);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function getComments(userId) {
    socketAxiosInstance
      .get(`/notification/comments/${userId}`)
      .then((res) => {
        if (res?.data?.status === true) {
          let data = res?.data?.data;

          data && setMessage(data?.notifications || []);
          data && setMsgCount(data?.count || 0);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  useEffect(() => {
    getCompanyName();
    getNotifications(userDetails?.id);
    getComments(userDetails?.id);
  }, []);

  const { connectionOn, handleNotifications, handleActiveUser } = useSocket();

  useEffect(() => {
    if (connectionOn == true) {
      handleNotifications((notification) => {
        if (notification.type == 1) {
          setNotifCount((prev) => prev + 1);
          setNoti((prev) => [notification, ...prev]);
        } else if (notification.type == 2) {
          setMsgCount((prev) => prev + 1);
          setMessage((prev) => [notification, ...prev]);
        }
        toast.open(
          {
            message: "New Notification",
            description: notification?.msg || "",
            name: notification?.name || "",
            date: notification?.date || "",
            time: notification?.time || "",
            type: "notification",
          },
          5000,
          true
        );
      });
    }
  }, [handleNotifications, connectionOn]);

  const [userList, setUserList] = useState([]);

  useEffect(() => {
    if (connectionOn == true && GetRole()) {
      handleActiveUser((userList) => {
        setUserList(userList);
      });
    }
  }, [handleActiveUser, connectionOn]);

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const { pathname } = useLocation();
  const { projectId, projectID, projecTId, projeCtId, proJectId, projEctId } =
    useParams();

  console.log("PATH", pathname.includes("/settings/"));

  const Space = ({ children }) => {
    return <div className="flex">{children}</div>;
  };

  const Badge = ({ count, children }) => {
    return (
      <div className="relative inline-block">
        {children}
        {count > 0 && (
          <span className="absolute top-0 p-1 right-0 bg-red-500 text-white w-4 h-4 flex items-center justify-center rounded-full text-[8px]">
            {count}
          </span>
        )}
      </div>
    );
  };

  const Dropdown = ({ overlay, children, trigger }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
      const handleClickOutside = (event) => {
        if (
          dropdownRef.current &&
          !dropdownRef.current.contains(event.target)
        ) {
          setIsOpen(false);
        }
      };

      if (isOpen) {
        document.addEventListener("mousedown", handleClickOutside);
      } else {
        document.removeEventListener("mousedown", handleClickOutside);
      }

      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [isOpen]);

    const toggleDropdown = () => {
      setIsOpen(!isOpen);
    };

    const handleTrigger = () => {
      if (trigger === "click") {
        toggleDropdown();
      }
      // You can add support for other trigger events here if needed
    };

    return (
      <div
        className="relative inline-block"
        onClick={handleTrigger}
        ref={dropdownRef}
      >
        <div>{children}</div>
        {isOpen && (
          <div className="absolute right-[100%] top-[70%] w-48 bg-white rounded-md shadow-lg z-[99]">
            {overlay}
          </div>
        )}
      </div>
    );
  };

  const getUnreadCount = () => {
    return noti.filter((noti) => !noti.is_read).length;
  };

  function Menu() {
    const navigate = useNavigate();

    const handleNavigate = (module, id) => {
      switch (module) {
        case "pr":
          navigate(
            `/procurement/purchase-requests/view/${id}`
          );
          break;
        case "rfq":
          navigate(`/procurement/rfq/view/${id}`);
          break;
        case "supplier_quotes":
          navigate(`/procurement/rfq/view/${id}`, {
            state: { active: 2 },
          });
          break;
        case "purchase_order":
          navigate(`/procurement/purchase-order/view/${id}`);
          break;
        case "sales_order":
          navigate(`/sales/sales-orders/view/${id}`);
          break;
        case "customer_quotes":
          navigate(`/sales/quotes/view/${id}`);
          break;
        case "supplier":
          navigate(`/procurement/suppliers/view/${id}`);
          break;
        default:
          console.error("Invalid module");
      }
    };
    const handleRead = async (id) => {
      axiosInstance
        .put(`/notification/update/is_read/${id}`, {
          is_read: 1,
        })
        .then((res) => {
          setNoti((prev) =>
            prev.map((noti) =>
              noti?.notificationId === id ? { ...noti, is_read: true } : noti
            )
          );
          setNotifCount(getUnreadCount());
        })
        .catch((err) => {});
    };

    function ClearAll() {
      axiosInstance
        .delete(`/notification/delete`)
        .then((res) => {
          setNoti([]);
          setNotifCount(0);
        })
        .catch((err) => {});
    }

    function MarkAll() {
      axiosInstance
        .get(`/notification/update/mark_all_as_read`)
        .then((res) => {
          setNoti((prev) =>
            prev.map((noti) => {
              return { ...noti, is_read: true };
            })
          );
          setNotifCount(0);
        })
        .catch((err) => {});
    }

    return (
      <div className="w-72 h-96 bg-white shadow-lg rounded-md overflow-hidden">
      <div className="w-full h-10 bg-slate-200 flex justify-between items-center">
        <p className="font-bold ml-2">Notification</p>
        <div className="flex items-center gap-2">
          {notifCount > 0 && (
            <button
              className="outline-none border-none text-xs font-normal px-2 py-1 rounded bg-[#048178] text-white cursor-pointer"
              onClick={MarkAll}
            >
              Mark as Read
            </button>
          )}
          {noti.length > 0 && (
            <button
              className="outline-none border-none text-xs font-normal px-2 py-1 rounded bg-[#048178] text-white cursor-pointer"
              onClick={ClearAll}
            >
              Clear All
            </button>
          )}
        </div>
      </div>
      <div className="w-full h-[90%] overflow-y-scroll">
        {noti.map((notification, idx) => (
          <div
            key={idx}
            className={`w-full my-1 p-1  gap-1 flex justify-between items-center cursor-pointer border-b`}
            onClick={() => {
              handleRead(notification.notificationId);
              handleNavigate(notification.module, notification.id);
            }}
          >
            <div className="px-2 w-[15%] ">
              <div className="w-8 h-8 bg-baseColor-primary flex justify-center items-center text-white font-medium text-lg rounded-full overflow-hidden">
                {notification.sender_imageUrl ? (
                  // <img
                  //   src={notification.sender_imageUrl}
                  //   width="50px"
                  //   alt="Sender"
                  // />
                  <img
                                            src={
                                              notification.sender_imageUrl
                                                ? notification.sender_imageUrl
                                                : null
                                            }
                                            width="50px"
                                            alt={`${notification.sender_imageUrl}`}
                                          />
                ) : (
                  `${notification.name.charAt(0)}`
                )}
              </div>
            </div>
            <div
              className={`w-[85%] ${
                notification.is_read ? "font-normal" : "font-semibold"
              }`}
            >
                <p className="pb-1 text-ellipsis text-slate-900 leading-5 text-xs">
                       {notification?.msg}
                     </p>
                     <p className="text-[10px] text-slate-700">
                       By {notification?.name}{" "}
                       {moment(notification?.date).format("DD-MMM-YYYY")} at{" "}
                       <span className="text-[8px] text-slate-700">
                         <NuDate
                           value={`${notification?.date} ${notification?.time}`}
                           format="hh:mm a"
                         />
                       </span>
                     </p>
            </div>
          </div>
        ))}
      </div>
    </div>
    );
  }

  function Message() {
    const navigate = useNavigate();

    const handleNavigate = (module, id) => {
      navigate(`/procurement/purchase-requests/view/${id}`);
    };

    const handleRead = async (id) => {
      axiosInstance
        .put(`/notification/update/is_read/${id}`, {
          is_read: 1,
        })
        .then((res) => {
          setNoti((prev) =>
            prev.map((noti) =>
              noti?.notificationId === id ? { ...noti, is_read: true } : noti
            )
          );
          setNotifCount(getUnreadCount());
        })
        .catch((err) => {});
    };

    function ClearAll() {
      axiosInstance
        .delete(`/notification/delete/comments`)
        .then((res) => {
          setMessage([]);
          setMsgCount(0);
        })
        .catch((err) => {});
    }

    function MarkAll() {
      axiosInstance
        .get(`/notification/update/comments/mark_all_as_read`)
        .then((res) => {
          setNoti((prev) =>
            prev.map((noti) => {
              return { ...noti, is_read: true };
            })
          );
          setNotifCount(0);
        })
        .catch((err) => {});
    }

    return (
      <>
        <div className="w-72 h-96 z-[99]  bg-white shadow-lg rounded-md overflow-hidden">
          <div className=" w-full h-10 bg-slate-200 flex justify-between items-center">
            <p className="font-bold ml-2">Comments</p>
            <div className=" flex items-center gap-2">
              {msgCount > 0 ? (
                <button
                  className=" outline-none border-none text-xs font-normal px-2 py-1 rounded bg-mainColor-300 text-white cursor-pointer bg-[#048178]"
                  onClick={MarkAll}
                >
                  Marks as read
                </button>
              ) : null}
              {message.length > 0 ? (
                <button
                  className=" outline-none border-none text-xs font-normal px-2 py-1 rounded bg-mainColor-300 text-white cursor-pointer bg-[#048178]"
                  onClick={ClearAll}
                >
                  Clear All
                </button>
              ) : null}
            </div>
          </div>
          <div className="w-full h-[90%] overflow-y-scroll">
            {message?.map((notification, idx) => {
              return (
                <>
                  <div
                    className={
                      // notification?.is_read ? "bg-white" : " bg-slate-100"
                    `w-full my-1 p-1 border-b gap-1 flex justify-between items-center cursor-pointer`}
                    onClick={() => {
                      notification?.is_read != true && handleRead(notification?.notificationId);
                      handleNavigate(notification.module, notification.id);

                    }}
                  >
               
                    <div className="px-2 w-[15%]">
                      {/* <NuAvatarGroup userdetails={[{name:`${notification?.sender_fName}`,imageUrl:`${notification?.sender_imageUrl}`}]} />    */}
                      <div className="w-8 h-8 bg-baseColor-primary  flex justify-center items-center text-white font-medium text-lg rounded-full overflow-hidden">
                        {notification.sender_imageUrl ? (
                          <img
                            src={
                              notification.sender_imageUrl
                                ? notification.sender_imageUrl
                                : null
                            }
                            width="50px"
                            alt={`${notification.sender_imageUrl}`}
                          />
                        ) : (
                          `${notification?.name?.charAt(0)}`
                        )}
                      </div>
                    </div>
                    <div
                      className={`w-[85%] ${
                        notification?.is_read
                          ? " font-normal "
                          : "font-medium  "
                      }`}
                    >
                      {/* <p className='font-semibold'>Admin <span className='font-normal'>to</span> Login Person</p> */}
                      <p className="pb-1 text-ellipsis text-slate-900 leading-5 text-xs">
                        {notification?.msg}
                      </p>
                      <p className="text-[10px] text-slate-700">
                        By {notification?.name}{" "}
                        {moment(notification?.date).format("DD-MMM-YYYY")} at{" "}
                        <span className="text-[8px] text-slate-700">
                          <NuDate
                            value={`${notification?.date} ${notification?.time}`}
                            format="hh:mm a"
                          />
                        </span>
                      </p>
                    </div>
                  </div>
                </>
              );
            })}
          </div>
        </div>
      </>
    );
  }

  const handleLogOut = async () => {
    setIsModalOpen(true);
  };

  function OnlineUsers({ list = [] }) {
    return (
      <>
        <div className="w-72 h-96 relative  bg-white shadow-lg rounded-md overflow-y-auto overflow-x-hidden px-2">
          <p className=" w-full sticky top-0 py-1 bg-white font-semibold text-xs 2xl:text-sm text-gray-900">
            Online User
          </p>
          {list &&
            list.map((user, index) => (
              <div
                className=" w-full flex justify-start items-center gap-x-3 my-1"
                key={index}
              >
                <div className=" w-[45px] h-[45px] rounded-full text-white  flex justify-center overflow-hidden items-center bg-baseColor-primary border border-white">
                  {user.image != "" && user.image != null ? (
                    <>
                      <img
                        src={user.image}
                        alt="#"
                        height={"45px"}
                        width="auto"
                      />
                    </>
                  ) : (
                    <>{getInitials(user?.name || "")}</>
                  )}
                </div>
                <p className=" text-gray-900 font-medium text-xs 2xl:text-sm">
                  {user?.name}
                </p>
              </div>
            ))}
        </div>
      </>
    );
  }

  const getInitials = (name) => {
    const names = name.split(" ");
    if (names.length > 1) {
      return names[0][0] + names[1][0];
    }
    return names[0][0];
  };

  const NavItems = [
    {
      icon: <DashboardSide/>,
      title: "Dashboard",
      hasSubMenu: false,
      hasAccess:true,
      link: GetDashboardRole("")?"/dashboard":GetDashboardRole("sales")?`/dashboard/sales`:GetDashboardRole("procurement")?`/dashboard/procurement`:GetDashboardRole("store")?`/dashboard/stores`:`/dashboard`,
    },
    
    {
      link:GetAccess("clients_view")?`/client-management/clients`:GetAccess("survey_report_view")?`/client-management/survey-report`:GetAccess("equipments_view")?`/client-management/equiments`:GetAccess("contracts_view")?`/client-management/contracts`:"#" ,
      icon: (
        <>
          <Bidding />
        </>
      ),
      title: "Client Management",
      access: GetAccess("client_management_module"),
      hasSubMenu: false,
      subMenu: [],
    },
   
   
    {
      link:GetAccess("calender_view")?`/inspection/calender`:GetAccess("schedule_view")?`/inspection/schedule`:"#" ,
      icon: (
        <>
          <Project />
        </>
      ),
      title: "Inspection",
      access: GetAccess("inspection_module"),
      hasSubMenu: false,
    },
    {
      link: GetAccess("schedules_view")?`/testingAndcommisioning/schedules`:"#",
      icon: (
        <>
          <Notes />
        </>
      ),
      title: "Commissioning",
      access: GetAccess("testing_and_commisioning_module"),
      hasSubMenu: false,
      subMenu: [],
    },

    {
      icon: <Timesheet/>,
       link:GetAccess("fire_extinguisher_view")?`/collectionAndreturn/fireExtinguisher`:GetAccess("fire_suppression_view")?`/collectionAndreturn/fireSuppression`:"#",
      title: "Refilling",
      hasAccess:["fire_extinguisher_view,fire_suppression_view"],
      hasSubMenu: false,
      subMenu: [
       
      ],
    },
   
    {
      icon: <Procurement/>,
         link:GetAccess("client_tickets_view")?`/tickets/client-tickets`:GetAccess("support_tickets_view")?`/tickets/support-tickets`:"#",
      title: "Tickets",
      hasAccess:["client_tickets_view","support_tickets_view"],
      hasSubMenu: false,
      subMenu: [
       
      ],
    },

    {
      link: GetAccess("invoice_outgoing_view")?`/invoice/invoice-outgoing`:"#",
      icon: (
        <>
          <Notes />
        </>
      ),
      title: "Invoice",
      access: GetAccess("Invoice_module"),
      hasSubMenu: false,
      subMenu: [],
    },
   
    {
      icon: <Sales/>,
        link:GetAccess("tasks_view")?`/tasks`:"#",

      title: "Tasks",
      hasAccess:["task_view"],
      hasSubMenu: false,
      subMenu: [
       
      ],
    },
   
    {
      icon: <Store/>,
      title: "Forms",
         link:GetAccess("forms_view")?`/forms`:"#",

      hasAccess:["forms_view"],
      hasSubMenu: false,
      subMenu: [
             ],
    },
    {
      link:GetAccess("report_view")?`/report`:"#", 
      icon: (
        <>
        <Report/>
        </>
      ),
      title: "Report",
      access: GetAccess("report_module"),
      hasSubMenu: false,
      subMenu: [],
      
    },
    {
         link:GetAccess("email_sent_view")?`/email/email-sent`:"#",
    
      icon: <Contacts />,
      title: "E-mail",
      hasAccess:["email_sent_view"],
      hasSubMenu: false,
      
      subMenu: [
       
      ],
    },
   
    {
      link:GetAccess("main_contractors_view")?`/contacts/main-contractors`:GetAccess("installers_view")?`/contacts/installers`:GetAccess("suppliers_view")?`/contacts/suppliers`:GetAccess("consultants_view")?`/contacts/consultants`:"#" ,
      icon: 
      <Members />,

      title: "Contacts",
      hasAccess:["main_contractors_view","installers_view","suppliers_view","consultants_view"],
      hasSubMenu: false,
    },
  ];

  const SettingsNavItem = [
    {
      icon: <CompanyInfoIcon/>,
      title: "Company Info",
      link:'/settings',
      hasAccess:"company_info_view"

    },
   
    {
      icon: <Role/>,
      title: "Role",
      link:'/settings/role',
      hasAccess:"role_view"
    },
    {
      icon: <Staff/>,
      title: "User",
      link:'/settings/user',
      hasAccess:"user_view"
    },
   
    {
      icon: <UserRole/>,
      title: "User Role",
      link:'/settings/user-role',
      hasAccess:"user_role_view"
    },
    {
      icon: <BellIcon color = "#999999"/>,
      title: "Notifications",
      link:'/settings/notifications',
      hasAccess:"notification_view"
    },
    {
      icon: <Reference/>,
      title: "Reference",
      link:'/settings/reffrence',
      hasAccess:"reference_view"
    },
    
    {
      icon: <PermissionIcon/>,
      title: "Approval Permission",
      link:'/settings/statuspermission',
      hasAccess:"reference_view"
    },
    {
      icon: <Email />,
      title: "Email Server",
      link:'/settings/emailserverdetails',
      hasAccess:"reference_view"
    },
  ];

  return (
    <>
      <style jsx>{`
        .circle-container .circle {
          position: relative;
          display: inline-block;
        }

        .circle-container .circle .circle-tooltip {
          visibility: hidden;
          max-width: 250px;
          height: 16px;
          background-color: #fff;
          color: #555;
          text-align: center;
          border-radius: 5px;
          padding: 5px;
          position: absolute;
          z-index: 20;
          top: 100%; /* Position the tooltip above the circle */
          left: 50%;
          transform: translateX(-50%);
          opacity: 0;
          transition: opacity 0.3s;
          border: 1px solid #048178;
        }

        .circle-container .circle:hover .circle-tooltip {
          visibility: visible;
          opacity: 1;
        }
      `}</style>
      <nav className=" w-full flex justify-between z-50">
        <div className=" w-4 lg:w-6/12 h-full p-3">
          <div className=" hidden h-full items-center lg:flex">
            {
              <div className=" flex justify-center items-center gap-2">
                {title.Country && (
                  <div className="max-w-[150px] h-10 overflow-hidden flex justify-center items-center">
                    <img
                      src={title.Country}
                      style={{ height: "40px", width: "auto" }}
                      alt="#fff"
                    />
                  </div>
                )}
                <span className=" text-base capitalize font-medium">
                  {title.Name || " "}
                </span>
              </div>
            }
          </div>
          <div className=" lg:hidden cursor-pointer" onClick={showDrawer}>
            <MenuOutlined />
          </div>
        </div>
        {GetRole() && (
          <>
            <div className=" w-[65%] h-[60px] mr-2 flex justify-end items-center">
              <div
                className="circle-container"
                style={{ display: "flex", alignItems: "center" }}
              >
                {userList && userList.length > 0 ? (
                  userList.slice(0, 10).map((name, index) => (
                    <React.Fragment key={index}>
                      {index == 9 ? (
                        <>
                          <div
                            className="circle text-xs"
                            style={{
                              width: "25px",
                              height: "25px",
                              borderRadius: "50%",
                              backgroundColor: "#3369ff",
                              color: "white",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontWeight: "normal",
                              marginLeft: index !== 0 ? "-10px" : "0", // Add overlap effect
                              position: "relative",
                              zIndex: 1 + index, // Stack circles on top of each other
                              transition: "all 0.3s ease",
                              cursor: "pointer",
                              border: "1px solid #fff",
                            }}
                          >
                            <div className="">
                              <Dropdown
                                overlay={<OnlineUsers list={userList} />}
                                trigger="click"
                              >
                                <div className=" w-full h-full text-xs whitespace-nowrap">
                                  10+
                                </div>
                              </Dropdown>
                            </div>
                          </div>
                        </>
                      ) : (
                        <div
                          className="circle text-xs"
                          style={{
                            width: "25px",
                            height: "25px",
                            borderRadius: "50%",
                            backgroundColor: "#3369ff",
                            color: "white",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontWeight: "normal",
                            marginLeft: index !== 0 ? "-10px" : "0", // Add overlap effect
                            position: "relative",
                            zIndex: 1 + index, // Stack circles on top of each other
                            transition: "all 0.3s ease",
                            cursor: "pointer",
                            border: "1px solid #fff",
                          }}
                        >
                          {name.image != "" && name.image != null ? (
                            <div className=" w-[25px] h-[25px] rounded-full flex justify-center items-center overflow-hidden">
                              <img
                                src={name.image}
                                alt="#"
                                className=" w-auto h-[35px] object-cover"
                              />
                            </div>
                          ) : (
                            <>{getInitials(name?.name || "")}</>
                          )}
                          <div className="circle-tooltip ">
                            <div className=" -mt-[5px] text-xs whitespace-nowrap">
                              {name?.name || "-"}
                            </div>
                          </div>
                        </div>
                      )}
                    </React.Fragment>
                  ))
                ) : (
                  <p> </p>
                )}
              </div>
            </div>
          </>
        )}
        <div className=" flex justify-center items-center">
          <div className="px-0.5 mr-2 bg-slate-100 w-7 text-gray-700 h-7 rounded-lg flex justify-center items-center  cursor-pointer">
            <Link
              to={
                hasMutipleOffice == true
                  ? `/main-page/dashboard`
                  : GetDashboardRole("")
                  ? `/dashboard`
                  : GetDashboardRole("sales")
                  ? `/dashboard/sales`
                  : GetDashboardRole("procurement")
                  ? `/dashboard/procurement`
                  : GetDashboardRole("store")
                  ? `/dashboard/stores`
                  : `/dashboard`
              }
            >
              <LayoutDashboard size={16} />
            </Link>
          </div>
          <div className="mr-2">
            <Space>
              <Badge count={msgCount}>
                <Dropdown overlay={<Message />} trigger="click">
                  <div className=" px-1  flex justify-center items-center  cursor-pointer text-gray-700 bg-slate-100 w-7  h-7 rounded-lg">
                  <MessageSquareDot size={16} />
                  </div>
                </Dropdown>
              </Badge>
            </Space>
          </div>
          <div className="mr-2">
            <Space>
              <Badge count={notifCount||0}>
                <Dropdown overlay={<Menu />} trigger="click">
                  <div className=" px-1  flex justify-center items-center  cursor-pointer bg-slate-100 text-gray-700 w-7  h-7 rounded-lg">
                  <BellDot size={16} />
                  </div>
                </Dropdown>
              </Badge>
            </Space>
          </div>

          <div class=" md:p-2 flex items-center">
            <div className="dropdown inline-block relative">
              <button className=" text-gray-700 outline-none border-none bg-transparent font-semibold md:px-4 flex items-center">
                <svg
                  className="fill-current h-4 w-4"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                >
                  <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />{" "}
                </svg>
                <div className=" relative w-9 h-9 mx-2 rounded-full bg-white overflow-hidden">
                  <div className="absolute z-10 bg-transparent top-0 left-0 w-full h-9 border rounded-full border-solid border-gray-400"></div>
                  {/* <div className="absolute z-20 bottom-0 right-0 bg-transparent w-1/2 h-9 border-8 rounded-r-full border-solid border-white -[#F4F2F8]"></div> */}
                  <div className="absolute z-30 w-full [calc(36px-4px)] h-full text-gray-600 [calc(36px-4px)] flex justify-center  capitalize items-center bg-transparent">
                    {
                      userDetails.image?
                      <img src={userDetails.image} alt="#"/>
                      :<div>{userDetails?.name?.charAt(0)}</div>
                    }
                  </div>
                </div>
                <div className=" hidden md:flex flex-col leading-none">
                  <p className="text-xs 2xl:text-sm font-semibold text-gray-500">
                    {userDetails?.name || " "}
                    {/* {userDetails?.userLastName || " "} */}
                  </p>
                </div>
              </button>
              <ul className="dropdown-menu  leading-none z-50 absolute hidden shadow-sm border rounded-lg">
                <li className="list-none">
                  <Link
                    to={`/profile`}
                    className="rounded-t text-xs  bg-white font-medium hover:bg-baseColor-quartary py-2  px-4 block whitespace-no-wrap"
                    href="#"
                  >
                    Profile
                  </Link>
                </li>

                <li className="list-none cursor-pointer">
                  <div
                    className="rounded-b text-xs  bg-white font-medium hover:bg-baseColor-quartary py-2  px-4 block whitespace-no-wrap"
                    href="#"
                    onClick={handleLogOut}
                  >
                    Log Out
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <ModalContainer
          visiable={isModalOpen}
          title="Want to Logout?"
          content="Are you sure to logout from this app!"
          handleClick={() => logout()}
          closeModal={() => setIsModalOpen(false)}
        />
      </nav>

      <Drawer title="" placement="left" onClose={onClose} open={open}>
        <div className=" h-[calc(100vh-110px)] flex flex-col items-center space-y-1 overflow-y-auto">
          { NavItems.map((item, index) => {
              const { icon, title, hasAccess, link } = item;
              return (
                <>
                  {(hasAccess == true ||
                    GetMultipleAccess(hasAccess || [])) && (
                    <NavLink
                      to={link}
                      className={({ isActive }) =>
                        isActive
                          ? `w-[100%]  rounded-[6px] p-1 overflow-hidden border bg-sky-300 block text-white`
                          : `w-[100%]  overflow-hidden p-1 border block rounded-[9px]`
                      }
                      onClick={onClose}
                    >
                      <div key={index} className=" flex gap-2 items-center">
                        <span className=" w-[28px] h-[28px] border rounded-[9px] flex items-center justify-center ">
                          {icon}
                        </span>
                        <div className=" mt-1 text-xs font-medium">{title}</div>
                      </div>
                    </NavLink>
                  )}
                </>
              );
            })}



          {pathname.includes("/settings/") &&
            SettingsNavItem.map((item, index) => {
              const { icon, title, hasAccess, link } = item;
              return (
                <>
                  {(hasAccess == true ||
                    GetMultipleAccess(hasAccess || [])) && (
                    <NavLink
                      to={link}
                      className={({ isActive }) =>
                        isActive
                          ? `w-[100%]  rounded-[6px] p-1 overflow-hidden border bg-sky-300 block text-white`
                          : `w-[100%]  overflow-hidden p-1 border block rounded-[9px]`
                      }
                      onClick={onClose}
                    >
                      <div key={index} className=" flex gap-2 items-center">
                        <span className=" w-[28px] h-[28px] border rounded-[9px] flex items-center justify-center ">
                          {icon}
                        </span>
                        <div className=" mt-1 text-xs font-medium">{title}</div>
                      </div>
                    </NavLink>
                  )}
                </>
              );
            })}

          <Link
            to="#"
            className="w-[100%]  rounded-[6px] p-1 overflow-hidden border hover:bg-sky-300 block hover:text-white"
            onClick={() => {
              handleLogOut();
              onClose();
            }}
          >
            <div className=" flex gap-2 items-center">
              <span className=" w-[28px] h-[28px] border rounded-[9px] flex items-center justify-center ">
                {/* <FontAwesomeIcon icon={icon} /> */}
              </span>
              <div className=" mt-1 text-xs font-medium">Logout</div>
            </div>
          </Link>

          {GetMultipleAccess([
            "company_info_view",
            "product_view",
            "marketing_view",
            "procurement_view",
            "sales_view",
            "payment_view",
            "store_view",
            "shipping_view",
            "maintenance_view",
            "user_view",
            "role_view",
            "user_role_view",
            "notification_view",
            "reference_view",
          ]) && (
            <Link
              to={`/settings/`}
              className="w-[100%]  rounded-[6px] p-1 overflow-hidden border hover:bg-sky-300 block hover:text-white"
              onClick={() => {
                handleLogOut();
                onClose();
              }}
            >
              <div className=" flex gap-2 items-center">
                <span className=" w-[28px] h-[28px] border rounded-[9px] flex items-center justify-center ">
                  <Settings />
                </span>
                <div className=" mt-1 text-xs font-medium">Settings</div>
              </div>
            </Link>
          )}
        </div>
      </Drawer>
    </>
  );
}

export default Navbar;
